import { isBoolean, isNumber, isObject, isString, isUndefined } from '@fxts/core';
import { QuantityLimitInputValue } from '../views/QuantityLimitInputField';

export function isValidQuantityLimitInputValue(value: unknown): value is QuantityLimitInputValue | undefined {
  return (
    isUndefined(value) ||
    (isObject(value) &&
      'quantity' in value &&
      isNumber(value.quantity) &&
      'status' in value &&
      isString(value.status))
  );
}

export class QuantityLimitHelper {
  private value?: QuantityLimitInputValue;

  constructor();
  constructor(quantity: number, is_quantity_public: boolean);
  constructor(quantity?: number, is_quantity_public?: boolean) {
    if (isNumber(quantity) && isBoolean(is_quantity_public)) {
      this.setValue(quantity, is_quantity_public);
    } else {
      this.setValue();
    }
  }

  getValue(): QuantityLimitInputValue | undefined {
    return this.value;
  }

  public setValue(): this;
  public setValue(quantity: number, is_quantity_public: boolean): this;
  public setValue(quantity?: number, is_quantity_public?: boolean): this {
    if (isNumber(quantity) && isBoolean(is_quantity_public)) {
      this.value = {
        quantity,
        status: is_quantity_public ? 'public' : 'private',
      };
    } else {
      this.value = undefined;
    }
    return this;
  }
}
